import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Portal } from '../portal';
import { toastsListStyle } from './styles';
function ToastsList({ children, offset }) {
    return (_jsx(Portal, { children: _jsx("ul", Object.assign({ css: toastsListStyle({ offset }), "data-testid": "toasts-list" }, { children: children })) }));
}
export default ToastsList;
